// Taken from https://github.com/NadavCohen/react-fork-ref
export function forkRef(...refs) {
    return function (node) {
        for (const ref of refs) {
            if (typeof ref === 'function')
                ref(node);
            else if (ref)
                ref.current = node;
        }
    };
}
//# sourceMappingURL=forkRef.js.map